export default __webpack_public_path__ + "static/t2-4835b0916fe60a8f17cd01a4f14c6268.jpg";